import React from "react";
import PropTypes from "prop-types";
import "./desktopNav.scss";
import { Store } from "../../../flux";
import Notifications from "./NavbarNav/Notifications";
import UserActions from "./NavbarNav/UserActions";
import { Link, useLocation } from "react-router-dom";
import NavbarSearch from "./NavbarSearch";

const DesktopNav = () => {
  const location = useLocation();

  const isActive = (itemPath) => {
    const currentPath = location.pathname;

    if (currentPath === itemPath) return true;
    if (itemPath === "/alerts" && currentPath.startsWith("/alerts/"))
      return true;
    if (itemPath === "/analysts" && currentPath.startsWith("/analyst/"))
      return true;
    if (
      itemPath === "/blogs/premium/" &&
      currentPath.startsWith("/blogs/premium/")
    )
      return true;
    if (
      itemPath === "/blogs/public" &&
      currentPath.startsWith("/blogs/public/")
    )
      return true;

    return false;
  };

  return (
    <div className="mainContainer">
      <div
        style={{
          width: window.screen.width < 1600 ? "22%" : "auto",
          marginRight: window.screen.width < 1600 ? "0%" : "1%",
          display: window.screen.width < 1000 ? "flex" : {},
        }}
      >
        <img
          id="main-logo"
          className="d-inline-block align-top mr-1"
          style={{ maxWidth: window.screen.width < 1600 ? "20px" : "30px" }}
          src={require("../../../images/bitcoin-live/logo.png")}
          alt="Shards Dashboard"
        />
        <span
          style={{ fontSize: window.screen.width < 1600 ? 16 : 20 }}
          className="d-none d-md-inline ml-1"
        >
          <span style={{ color: "#f1591e" }}>BITCOIN</span>{" "}
          <span style={{ color: "#FAA61A" }}>LIVE</span>
        </span>
      </div>
      <div
        style={{
          width: window.screen.width < 1000 ? "auto" : "10%",
          marginLeft: window.screen.width >= 1600 ? "2%" : {},
        }}
      >
        <NavbarSearch />
      </div>
      <div className="navDiv">
        {(Store.getSidebarItems() || []).map((item, idx) => (
          <Link to={item.to} key={idx}>
            <label
              className={`navLabel ${isActive(item.to) ? "navLabel-active" : ""}`}
            >
              {item.title}
            </label>
          </Link>
        ))}
      </div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <Notifications />
        <UserActions />
      </div>
    </div>
  );
};

DesktopNav.propTypes = {
  /**
   * The layout type where the MainNavbar is used.
   */
  layout: PropTypes.string,
  /**
   * Whether the main navbar is sticky to the top, or not.
   */
  stickyTop: PropTypes.bool,
};

export default DesktopNav;
